import Link  from '../../components/link';
import React from 'react';

export default function ThankYou({ children, onLoginClick }) {
  return (
    <React.Fragment>
      <div className="block inset">
        <h3>Thank You!</h3>
        {children}
        <CallCustomerSuccess/>
      </div>
      <div className="block inset">
        <a onClick={onLoginClick}>Back to login</a>
      </div>
    </React.Fragment>
  );
}


function CallCustomerSuccess() {
  return (
    <div className="call-customer-success">
      <Link href="tel:1-800-727-0445" className="call-customer-success__link" target="_self" external>
        1-800-727-0445<br/>
        Broadly Customer Support
      </Link>
    </div>
  );
}
